import { graphql } from "react-relay";

export const RevokeApiKeysMutation = graphql`
  mutation RevokeApiKeysMutation($input: RevokeAPIKeysInput!) {
    revokeAPIKeys(input: $input) {
      problems {
        message
      }
      revokedKeys {
        id
        identity
        revokedAt
      }
    }
  }
`;
